module.exports = __webpack_public_path__ + "img/globalsyntax.b78c48ae.png";